import { Component } from 'react';
import styled from 'styled-components';
import { academyCustomCSS } from '~/constants/academyCustomCSS';
import TruncatedDiv from '../../widget/truncated-div';
import { theme } from '../../../styles';
import academyStyles from './academy-styles';
import AcademyIconSvgCollection from './academy-icon-svg-collection';

export default class AcademyThemeCollectionCard extends Component {
  constructor(props) {
    super(props);
    this.state = { name: this.props.name, description: this.props.description };
    if (this.props.collectionId) {
      // Allows customers to set the name and description on the learner view
      window.collectionCardsUpdaters = window.collectionCardsUpdaters || {};
      window.collectionCardsUpdaters[this.props.collectionId] = ({ name, description }) => {
        if (name) {
          this.setState({ name });
        }
        if (description) {
          this.setState({ description });
        }
      };
    }
  }

  TRANSLATED_COLLECTION = I18n.t('common.academy.content.collection');

  render() {
    const { isAdmin } = this.props;
    const name = isAdmin ? this.props.name : this.state.name;
    const description = isAdmin ? this.props.description : this.state.description;

    return (
      <ContentCard
        className={`${academyCustomCSS.cardList.card} ${this.props.className}`}
        isAdmin={isAdmin}
        onClick={this.props.onClick ? this.props.onClick : () => {}}
      >
        <a
          href={this.props.url}
          onClick={(e) => {
            e.preventDefault();
            window.location.href = this.props.url;
          }}
        >
          <ContentCardInner isAdmin={isAdmin} className={academyCustomCSS.cardList.cardContentInner}>
            <CollectionBanner
              className={academyCustomCSS.cardList.cardImage}
              bannerImage={this.props.bannerImage || APP_CONSTANTS.DEFAULT_COVER_IMAGES.ACADEMY_COLLECTION_BANNER}
            />
            <ContentCardContent className={academyCustomCSS.cardList.cardBody}>
              <h3 className={academyCustomCSS.cardList.cardTitle}>
                <TruncatedDiv text={name || ' '} numLines={3} />
              </h3>
              <ContentCardContentDescription className={academyCustomCSS.cardList.cardDescription}>
                <TruncatedDiv text={description || ' '} numLines={3} />
              </ContentCardContentDescription>
            </ContentCardContent>
            <ContentCardFooter className={academyCustomCSS.cardList.cardFooter}>
              <ContentCardIcon className={academyCustomCSS.cardList.cardContentTypeLabel}>
                <AcademyIconSvgCollection height={16} color="#1B324B" />
                <span>{this.TRANSLATED_COLLECTION}</span>
              </ContentCardIcon>
              {this.getContentCount()}
            </ContentCardFooter>
          </ContentCardInner>
        </a>
        {this.props.moreOptions}
      </ContentCard>
    );
  }

  getContentCount = () => {
    const TRANSLATED_NUM_ITEMS = I18n.t('js.academy.content_card.num_item', {
      count: this.props.numContent,
    });

    return <div className={`${academyCustomCSS.cardList.cardItemsCount} content-count`}>{TRANSLATED_NUM_ITEMS}</div>;
  };
}

const ContentCard = styled.div`
  transition: all 0.3s ease-in-out;
  margin-bottom: 4rem;
  position: relative;
  width: ${academyStyles.card.cardWidth}px;
  height: ${academyStyles.card.cardHeight}px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 24px 0 rgba(161, 179, 200, 0.25);
  &:hover {
    box-shadow: 0 3px 25px rgba(161, 179, 200, 0.7);
    ${(props) => !props.isAdmin && 'transform: translateY(-1px);'}
  }
  ${(props) =>
    props.isAdmin &&
    `
    width: 100%;
    margin: 0;
  `}
  a {
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
    &[href='javascript:void(0);'] {
      cursor: default;
    }
  }
  @media (max-width: 420px) {
    width: 100%;
  }
`;

const ContentCardInner = styled.div`
  position: relative;
  border-radius: 6px;
  height: 100%;
`;

const CollectionBanner = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url(${(props) => props.bannerImage}) center center no-repeat;
  background-size: cover;
  border-radius: 6px;
`;

const ContentCardContent = styled.div`
  width: 100%;
  position: absolute;
  bottom: 15px;
  left: 0;
  padding: 0 25px 48px;
  box-sizing: border-box;
  border-radius: 0 0 6px 6px;
  display: flex;
  flex-direction: column;
  h3 {
    font-size: 2.25rem;
    color: #1b324b;
    margin-bottom: 10px;
    ${theme.font.bold}
  }
`;

const ContentCardContentDescription = styled.div`
  font-size: 0.875rem;
  line-height: 1.5;
  color: rgba(27, 50, 75, 0.8);
  ${theme.font.regular}
`;

const ContentCardFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 25px;
  right: 25px;
  box-sizing: border-box;
  padding: 15px 0;
  border-top: solid 1px rgba(27, 50, 75, 0.2);
  font-size: 0.875rem;
  color: rgba(27, 50, 75, 0.8);
  height: 48px;
  cursor: default;
  display: flex;
  justify-content: space-between;
  .content-count {
    margin-left: auto;
    ${theme.font.semibold}
  }
`;

const ContentCardIcon = styled.div`
  display: flex;
  align-items: center;
  color: rgba(27, 50, 75, 0.8);
  span {
    font-size: 0.6875rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    display: inline-block;
    margin-left: 10px;
  }
`;
